module.exports = __webpack_public_path__ + "img/gift.89053c81.png";